module.exports = __webpack_public_path__ + "img/2.7abad5f0.png";